module.exports = __webpack_public_path__ + "img/donglongdong-wondertown.412bdf8.jpg";